import cookie from './treffcook';

// Updates the chatbox toggle button.
exports.updateSliderToggle = item => {
  if ($(item).hasClass('chatbox-closed')) {
    $(item)
      .removeClass('chatbox-closed')
      .addClass('chatbox-open')
      .find('i')
      .removeClass('fa-chevron-up')
      .addClass('fa-chevron-down');
    cookie.Set('dcbxmin', 0, 3600, '/');
  } else {
    $(item)
      .removeClass('chatbox-open')
      .addClass('chatbox-closed')
      .find('i')
      .removeClass('fa-chevron-down')
      .addClass('fa-chevron-up');
    cookie.Set('dcbxmin', 1, 3600, '/');
  }
};
exports.try2play = () => {
  const dcsound = document.getElementById('dcaudio');
  dcsound.play();
};
// Global call to obtain all chat posts.
// It is executed by an interval.
exports.checkChatState = () => {
  $.ajax({
    url: '/directchat/ajax_chat.php',
    method: 'POST',
    type: 'json',
    data: {
      mode: 'checkStates'
    },
    success: data => {
      const response = $.parseJSON(data);
      const total = parseInt(response.total, 10);
      if (total > 0) {
        $('body')
          .find(
            '#navbar-chat-info-bubble, #unread-chat-info-bubble, #dc-chat-info-bubble'
          )
          .html(response.total)
          .show();
        if (parseInt(cookie.Get('numofnew'), 10) < parseInt(total, 10)) {
          if (parseInt(cookie.Get('private_sound'), 10) === 1) {
            const dcsound = document.getElementById('dcaudio');
            dcsound.play();
            // console.log('lib private_sound', cookie.Get('private_sound'));
          }
          cookie.Set('numofnew', total, 3600, '/');
        }
        if (Object.keys(response.new_messages).length > 0) {
          $.each(response.new_messages, (cid, num) => {
            const itenID = `#${cid}_message_info`;
            if (num > 0) {
              $('body')
                .find(itenID)
                .html(num)
                .show();
            } else {
              $('body')
                .find(itenID)
                .html('')
                .hide();
            }
          });
        }
      } else {
        $('body')
          .find(
            '#navbar-chat-info-bubble, #unread-chat-info-bubble, #dc-chat-info-bubble'
          )
          .hide();
      }
    }
  });
};



// WEBPACK FOOTER //
// ./src/main/javascripts/lib/directchat_lib.js